import Head from 'next/head'
import Image from "next/legacy/image";
import styles from "../../styles/pages/Rooms.module.scss"
import Link from 'next/link'
import Topbanner from '../../components/Topbanner/Topbanner'
import { roomsData } from "../../data/roomsData"
import { useEffect, useState } from 'react';
import NewLoader from '../../components/Loader/NewLoader';
import { useRouter } from 'next/router';
import moment from "moment";
import { addDays, differenceInDays } from 'date-fns';
import BreadCrumbSchema from '../../components/Schema/HotelSchema/breadcrumb';
import AccomodationSchema from '../../components/Schema/HotelSchema/accomodation';

export const getStaticProps = async () => {
    return {
        props: {
            Allrooms: roomsData,
        }
    }
}

export default function RoomsandSuites({ Allrooms }) {
    const router = useRouter();
    const [loader, setLoader] = useState(false);
    const [noOfNights, setNoOfNights] = useState(router.query.npOfNights || 1);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(() => {
        const tomorrow = addDays(new Date(), 1);
        return tomorrow;
    });

    const [checkin, setCheckin] = useState({
        day: router.query.checkinDay || "",
        month: router.query.checkinMonth || "",
        year: router.query.checkinYear || "",
    });

    const [checkout, setCheckout] = useState({
        day: router.query.checkoutDay || "",
        month: router.query.checkoutMonth || "",
        year: router.query.checkoutYear || "",
    });

    useEffect(() => {
        const updateDateState = (date, setStateFunction) => {
            if (date !== null) {
                const day = date.getDate();
                const month = (date.getMonth() + 1).toString().padStart(2, "0");
                const year = date.getFullYear();
                setStateFunction({ day, month, year });
            }
        };

        updateDateState(startDate, setCheckin);
        updateDateState(endDate, setCheckout);

        const nights = moment(endDate).diff(moment(startDate), 'days');
        setNoOfNights(nights > 0 ? nights : 1);
    }, [startDate, endDate]);

    useEffect(() => {
        const nights = differenceInDays(endDate, startDate);
        setNoOfNights(nights);
    }, [startDate, endDate]);

    const formated_start_date = moment(startDate).format("YYYY-MM-DD");
    const formated_end_date = moment(endDate).format("YYYY-MM-DD");

    const handleSubmit = async (event, hotelId) => {
        event.preventDefault();

        setLoader(true);

        try {
            await router.push(
                `/searchresults/?hotelID=${hotelId}&checkinDay=${checkin.day}&checkinMonth=${checkin.month}&checkinYear=${checkin.year}&checkoutDay=${checkout.day}&checkoutMonth=${checkout.month}&checkoutYear=${checkout.year}&room=1&adult=2&children=0&checkIn=${formated_start_date}&checkOut=${formated_end_date}&noOfNights=${noOfNights}`,
                undefined,
                { shallow: false }
            );

        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoader(false);
        }
    };

    return (
        <>
            <Head>
                <title>Book Best hotel Room in Shimla- The Twin Towers hotel in Shimla  | Luxury and Deluxe rooms</title>
                <meta name="description" content="Book your stay at The Twin Towers Hotel in Shimla for Family, Couple luxurious, elegant rooms with stunning views. Reserve now for an unforgettable experience!" />
                <link rel="icon" href="/favicon.svg" />
                <link rel="canonical" href="https://www.hoteltwintowers.com/hotel-room-in-shimla" />
                <meta name="keywords" content="Shimla Hotel Room Price, Shimla Hotel Booking, shimla hotel room booking, room suites, best tourist places to visit in shimla, hotel room images, room luxury, hotel room types, shimla room rent "></meta>
            </Head>

            {loader && <NewLoader />}
            <Topbanner bgImage={"/images/our-rooms-banner.png"} title={"Explore the best Room Suites"} />
            <section className={`${styles.rooms} common_padding`}>
                <div className='container'>
                    {Allrooms.map((room, index) => (
                        <div className={`${styles.rooms_main} row align-items-center`} key={index}>
                            <div className={`${styles.rooms_left} col-md-4`}>
                                <img src={room.roomsImage} alt={room.roomName} />
                            </div>
                            <div className={`${styles.rooms_center} col-md-5 common_title`}>
                                <h2>{room.roomName}</h2>
                                <p className={styles.rooms_center_desc}>{room.roomDesc}</p>
                                <div className={styles.rooms_center_amen}>
                                    <div>
                                        <Image src="/icons/bed.svg" height={20} width={23} alt="bed-icon"></Image>
                                        {/* <p className=''> {room.beds}</p> */}
                                    </div>
                                    <div className={styles.right_amen}>
                                        <Image src="/icons/guests.svg" height={20} width={23} alt="guests-icon"></Image>
                                        {/* <p className=''> {room.guests}</p> */}
                                    </div>
                                    <div className={styles.right_amen}>
                                        <Image src="/icons/coffee.svg" height={20} width={23} alt="coffee-icon"></Image>
                                        {/* <p className=''> {room.guests}</p> */}
                                    </div>
                                </div>
                            </div>
                            <div className={`${styles.rooms_right} col-md-3 common_title`}>
                                <button className='common_btn' onClick={(event) => handleSubmit(event, 17)}>Book Now</button>
                                {/* <a href="https://thetwintowers.bookingjini.com/property" target="_blank" rel="noopener noreferrer" className="common_btn">
                                    Book Now
                                </a> */}
                                <Link className='secound_common_btn' href={`/hotel-room-in-shimla/${room.slug}`}>More Details</Link>
                            </div>
                        </div>
                    ))}

                </div>
            </section>
            <BreadCrumbSchema />
            <AccomodationSchema />
        </>
    )
}
